module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "mu-ripple"
    }
  }, [_c('div', {
    staticClass: "mu-circle-ripple",
    style: (_vm.styles)
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26da45e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/internal/circleRipple.vue
// module id = 426
// module chunks = 1